import { render } from "./SlotList.vue?vue&type=template&id=23a2f038&scoped=true"
import script from "./SlotList.vue?vue&type=script&lang=js"
export * from "./SlotList.vue?vue&type=script&lang=js"

import "./SlotList.vue?vue&type=style&index=0&id=23a2f038&scoped=true&lang=css"
import "./SlotList.vue?vue&type=style&index=1&id=23a2f038&lang=css"

import exportComponent from "../../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a2f038"]])

export default __exports__